import { Component, OnInit } from '@angular/core';
import { MessagesService } from '../messages/messages.service';
import { ErrorHandler } from '../utils/error-handler';
import { RunProcessingService } from './run-processing.service';
import { RunDetails } from './model/RunDetails';
import { DilutionPooling } from './model/DilutionPooling';
import { saveAs as saveByFileSaver } from "file-saver";
import { DatePipe } from '@angular/common';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { Comment } from './model/comment';
import { ActivatedRoute } from '@angular/router';
import { DUELESS_BLOCK_NAME, DUELESS_COLOR, DUEMORE_BLOCK_NAME, DUEMORE_COLOR, Lane, LaneBlock, LaneViewDataDTO, OVERDUE_BLOCK_NAME, OVERDUE_COLOR, PHIX_BLOCK_NAME, PHIX_COLOR } from '../run-planning/models/runPlanConstants';
import { RunPlanDto } from './model/RunPlanDto';
import { Library } from "../run-planning/models/libraryDTO";
import rfdc from 'rfdc';

@Component({
  selector: 'app-run-processing',
  templateUrl: './run-processing.component.html',
  styleUrls: ['./run-processing.component.css']
})
export class RunProcessingComponent implements OnInit {

  readonly buttonsRound = {
    "margin-bottom": "5px",
    "margin-top": "5px",
    "font-weight": "bold",
    "font-size": "14px",
    "padding": "7px 0px 7px 0px",
    "width": "96%",
    "border-radius": "5px"
  }

  valueToSearch: string;
  blocked = false;
  selectedLabId: string;
  selectableLab: any;
  selectedRun: RunDetails;

  showCommentDialog = false;
  urlCheck: string;
  previewComment: Comment;
  showPlateView = false;
  errorHandler: ErrorHandler = new ErrorHandler;
  puid: string;
  mapOfStatusSaves = new Map();
  comments: Comment[] = [];
  newComment: Comment;
  commentAvailable: boolean;
  laneViewMap = new Map<string, any[]>();
  laneViewData: RunPlanDto[] = [];
  lanetableVisible: boolean = false;
  laneViewLibraryData: any[];
  scrollableColsforLanelist: any[];
  scrollableColsforLibData: any[];
  laneViewList: any[];
  laneBlockMap = new Map();
  lanes: Lane[] = [];
  laneBlocks: LaneBlock[] = [];
  listofRunLibraries: any[] = [];
  commentPopup = false;
  seqRunFlag: boolean = true;
  loading: boolean = false;
  libraryIdTabledata: any[] = [];
  laneLibFilterValue: any;
  rowsCount: any = 0;
  clone = rfdc();
  containerLibMap = new Map();
  laneSelectionMap = new Map();

  // table properties and values
  filterOptions: any[];
  selectedStates: string[] = [];
  fromDate: Date;
  toDate: Date;
  showFilter: boolean = true;
  run: any;
  runProcesses: any[];
  librarySelectionList = [];
  expandedLane: string = null;
  runActionSelection: string;
  actionOptions: SelectItem[] = [];
  showRemoveLibsSideBar: boolean = false;
  removalLibraryObjects: any[] = [];
  removalLibraryIds: string[] = [];
  removalEmptyLibsMessage: string = null;
  libraryCount: number = 0;
  removelErrorReutrnMessage: string = null;
  removalContainedLibIds: string[] = [];

  userEmail: string = null;
  userPassword: string = null;
  processViewSidebar: boolean = false;
  sequencingRunContinuationValue: string;
  libraryInfo: Array<Library>;

  showFeedbackDialog = false;
  libraryData : Array<any>;
  isRunFeedbackFileNotSelected: boolean = true;
  runLaneslibraryIds: any[] =[];

  constructor(private activatedroute: ActivatedRoute, private _messagesService: MessagesService, private runProcessingService: RunProcessingService,
    private datepipe: DatePipe, private confirmationService: ConfirmationService) { }

  ngOnInit() {
    this.puid = localStorage.getItem('PUID');
    this.selectableLab = JSON.parse(localStorage.getItem('lab'));
    this.selectedLabId = this.selectableLab.lab._id;

    this.runProcessingService.getRunsForLab(this.selectedLabId).subscribe({
      next : (results) => {
        if(results.data != undefined)
          this.runProcesses = results.data['data'];
        else
          this.runProcesses = [];
      },
      error: (error: any) => {
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    })

    this.commentAvailable = true;
    this.previewComment = new Comment();
    this.newComment = new Comment();

    this.populateMapOfStatusSaves();
    this.showPlateView = false;

    this.activatedroute.params.subscribe(params => {
      this.valueToSearch = params['id'];
      if (this.valueToSearch) {
        this.getDataForRunProcessing();
      }
    });

    this.filterOptions= [
      {label:"PREPARE_DATA_FOR_ANALYSIS", value:"PREPARE_DATA_FOR_ANALYSIS"},
      {label:"DIL_AND_POOL_STARTED", value:"DIL_AND_POOL_STARTED"},
      {label:"DIL_AND_POOL_FINISHED", value:"DIL_AND_POOL_FINISHED"},
      {label:"SEQ_RUN_FINISHED", value:"SEQ_RUN_FINISHED"},
      {label:"SEQ_RUN_STARTED", value:"SEQ_RUN_STARTED"},
      {label:"PA_STARTED", value:"PA_STARTED"},
      {label:"PA_FINISHED", value:"PA_FINISHED"},
      {label:"RUN_REVIEW_STARTED", value:"RUN_REVIEW_STARTED"},
      {label:"COMPLETED", value:"COMPLETED"},
      {label:"REDO", value:"REDO"},
    ];

    this.scrollableColsforLanelist = [
      { 'header': 'LaneId', 'field': 'laneId', 'selected': false },
      { 'header': 'Due Date', 'field': 'dueDate', 'selected': false },
      { 'header': 'Const. ID', 'field': 'constraintId', 'selected': false },
      { 'header': 'Amount of Libs', 'field': 'totalLibIds', 'selected': false },
      { 'header': 'Reads', 'field': 'totalReadsCount', 'selected': false },
      { 'header': 'Phix', 'field': 'phixPercentage', 'selected': false },
      { 'header': '', 'field': 'rowExpand', 'selected': false }
    ]
    this.scrollableColsforLibData = [
      { 'header': 'LibraryID', 'field': 'libraryId', 'selected': false },
      { 'header': 'Project', 'field': 'projectName', 'selected': false },
      { 'header': 'Sample', 'field': 'sampleName', 'selected': false },
      { 'header': 'Planned Reads', 'field': 'missingReads', 'selected': false },
      { 'header': 'Status', 'field': 'status', 'selected': false },
      { 'header': 'Tag', 'field': 'tagInfo', 'selected': false },
      { 'header': 'Plate-ID', 'field': 'plateID', 'selected': false },
      { 'header': 'Position', 'field': 'samplePosition', 'selected': false },
      { 'header': 'Due date', 'field': 'dueDate', 'selected': false }
    ]

    this.actionOptions = [
      { label: 'Remove', value: 'Remove' }
    ];
  }

  reloadRuns(){
    this.getAllRuns();
    this.showPlateView = false;
    this.urlCheck = null;
    this.comments = null;
    this.previewComment = this.getPreviewComment();
    this.showCommentDialog = false;
    this.valueToSearch = '';
    this.seqRunFlag = false;
  }

  onApplyFilter(){}

  getAllRuns(){
    this.blocked = true;
    let runProcess = this.runProcessingService.getRunsForLab(this.selectedLabId);
    runProcess.subscribe({ next : (results) => {
      if(results.data != undefined)
        this.runProcesses = results.data['data'];
      else
        this.runProcesses = [];
      this.blocked = false;
    },error: (error: any) => {
      this.blocked = false;
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
    }
    })
  }

  populateMapOfStatusSaves() {
    this.mapOfStatusSaves.set("PREPARE_DATA_FOR_ANALYSIS", "prepareDataForAnalysis");
    this.mapOfStatusSaves.set("DIL_AND_POOL_STARTED", "dilAndPoolStarted");
    this.mapOfStatusSaves.set("DIL_AND_POOL_FINISHED", "dilAndPoolFinished");
    this.mapOfStatusSaves.set("SEQ_RUN_FINISHED", "seqRunFinished");
    this.mapOfStatusSaves.set("SEQ_RUN_STARTED", "seqRunStarted");
    this.mapOfStatusSaves.set("PA_STARTED", "primaryAnalysisStarted");
    this.mapOfStatusSaves.set("PA_FINISHED", "primaryAnalysisFinished");
    this.mapOfStatusSaves.set("RUN_REVIEW_STARTED", "runReviewStarted");
    this.mapOfStatusSaves.set("COMPLETED", "runReviewFinished");
    this.mapOfStatusSaves.set("RUN_FEEDBACK_RECEIVED", "runFeedbackReceived");
    this.mapOfStatusSaves.set("RERUN_SEQ_RUN", "reRunSeqRun");
    this.mapOfStatusSaves.set("RERUN_RUN", "reRunRun");
    this.mapOfStatusSaves.set("FAILED", "runFailed");
    this.mapOfStatusSaves.set("RUN_COMPLETED", "runCompleted");
    this.mapOfStatusSaves.set("COMPLETE_DIL_AND_POOL", "completeDilutionAndPooling");
  }

  dilAndPoolStarted(status: string) {
    this.selectedRun.dilutionAndPoolingStartedPUID = this.puid;
    this.selectedRun.dilutionAndPoolingStartedDateTime = new Date();
    this.selectedRun.status = status;
    this.saveRun();
  }

  dilAndPoolFinished(status: string) {
    this.selectedRun.dilutionAndPoolingFinishedPUID = this.puid;
    this.selectedRun.dilutionAndPoolingFinishedDateTime = new Date();
    this.selectedRun.status = status;
    this.saveRun();
  }

  seqRunFinished(status: string) {
    this.selectedRun.sequencingRunFinishedPUID = this.puid;
    let date = new Date(this.selectedRun.sequencingRunStartedDate);
    date.setHours(date.getHours() + this.selectedRun.runDuration);
    this.selectedRun.sequencingRunFinishedDateTime = date;
    this.selectedRun.status = status;
    this.saveRun();
  }

  seqRunStarted(status: string) {
    this.selectedRun.sequencingRunStartedPUID = this.puid;
    this.selectedRun.sequencingRunStartedDate = new Date();
    this.selectedRun.sequencingStarted = true;
    this.selectedRun.actualStartDate = this.selectedRun.sequencingRunStartedDate;
    let date = new Date(this.selectedRun.sequencingRunStartedDate);
    date.setHours(date.getHours() + this.selectedRun.runDuration);
    this.selectedRun.actualFinishDate = date;
    this.selectedRun.status = status;
    this.saveRun();
  }

  saveRun() {
    this.blocked = true;
    this.runProcessingService.updateRunStatus(this.selectedRun).subscribe(
      results => {
        this.selectedRun = results.data;
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Run status updated successfully!' });
        this.seqRunFlag = true;
        this.processViewSidebar = false;
        this.blocked = false;
        this.commentPopup = false;
      }, error => {
        this.handleError(error);
        this.commentPopup = false;
      }
    )
  }

  primaryAnalysisStarted(status: string) {
    this.selectedRun.primaryAnalysisStartedDateTime = new Date();
    this.selectedRun.primaryAnalysisStartedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRun()
  }

  primaryAnalysisFinished(status: string) {
    this.selectedRun.primaryAnalysisFinishedDateTime = new Date();
    this.selectedRun.primaryAnalysisFinishedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRun()
  }

  runReviewStarted(status: string) {
    this.selectedRun.runReviewStartedDateTime = new Date();
    this.selectedRun.runReviewStartedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRun()
  }

  reRunSeqRun(status: string){
    this.selectedRun.reRunSeqRunPUID = this.puid;
    this.selectedRun.reRunSeqRunDateTime = new Date();
    this.selectedRun.status = status;
    this.saveRun()
  }

  reRunRun(status: string){
    this.selectedRun.reRunSeqRunPUID = this.puid;
    this.selectedRun.reRunSeqRunDateTime = new Date();
    this.selectedRun.status = status;
    
    this.blocked = true;
      this.runProcessingService.reRunRun(this.selectedRun).subscribe(
        result => {
          this.selectedRun = result.data;
          this.comments = this.selectedRun.comments;
          this.previewComment = this.getPreviewComment();
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Run has been cancelled!', detail: 'Rerun is successful & Run status has been changed to RERUN_RUN.' });
          this.blocked = false;
          this.showFeedbackDialog = false;
          this.removeRunSelection()
          this.reloadRuns()
        }, error => {
          this.blocked = false;
          this.handleError(error);
        }
      )
  }

  runFeedbackReceived(status: string){
    this.selectedRun.runFeedbackReceivedPUID = this.puid;
    this.selectedRun.runFeedbackReceivedDateTime = new Date();
    this.selectedRun.status = status;
    this.saveRun()
  }

  runFailed(status: string){
    this.selectedRun.sequencingRunFinishedPUID = this.puid;
    this.selectedRun.sequencingRunFinishedDateTime = new Date();
    this.selectedRun.status = status;
    this.saveRun()
  }

  runCompleted(status: string){
    this.selectedRun.completionPUID = this.puid;
    this.selectedRun.completionDateTime = new Date();
    this.selectedRun.status = status;
    this.showFeedbackDialog = false;
    this.saveRun()
  }

  resetValues(){
    this.selectedRun.dilutionAndPoolingStartedDateTime = null
    this.selectedRun.dilutionAndPoolingStartedPUID = null
    this.selectedRun.dnpWorkfileDateTime = null
    this.selectedRun.dnpWorkfilePUID = null
    this.selectedRun.dilutionAndPoolingFinishedDateTime = null
    this.selectedRun.dilutionAndPoolingFinishedPUID = null
    this.selectedRun.sequencingRunStartedDate = null
    this.selectedRun.sequencingRunStartedPUID = null
    this.selectedRun.sequencingRunFinishedDateTime = null
    this.selectedRun.sequencingRunFinishedPUID = null
    this.selectedRun.runFeedbackReceivedDateTime = null
    this.selectedRun.runFeedbackReceivedPUID = null
  }

  runReviewFinished(status: string) {
    // Reset values
    this.resetValues()
    
    this.selectedRun.runReviewFinishedDateTime = new Date();
    this.selectedRun.runReviewFinishedPUID = this.puid;
    this.selectedRun.status = status;
    this.saveRun()
  }


  searchForRunWIthFilter() {
    if (!this.valueToSearch || this.valueToSearch.trim() == '') {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Value Not Entered', detail: 'Please Enter the value to search.' });
      return;
    }
    this.getDataForRunProcessing();

  }

  runViewVisbility(event) {
    this.valueToSearch = event.data.runId;
    this.getDataForRunProcessing();
  }

  removeRunSelection(){
    this.selectedRun = null;
    this.showPlateView = false;
    this.urlCheck = null;
    this.comments = null;
    this.selectedRun = null;
    this.previewComment = this.getPreviewComment();
    this.showCommentDialog = false;
    this.valueToSearch = '';
    this.seqRunFlag = false;
  }

  getDataForRunProcessing() {
    this.blocked = true;
    this.showPlateView = false;
    let runProcess = this.runProcessingService.getRunForLabAndRunId(this.selectedLabId, this.valueToSearch.trim());
    runProcess.subscribe({next:(results) => {
      if (results.data) {
        this.selectedRun = results.data;
        this.libraryInfo = this.selectedRun.libraryInfo;
        this.urlCheck = this.selectedRun.flowcell;
        this.comments = this.selectedRun.comments;
        this.previewComment = this.getPreviewComment();
        this.showCommentDialog = false;
        this.valueToSearch = '';
        if (this.selectedRun.sampleSheetURL && this.selectedRun.runConfigURL && this.selectedRun.status == 'PREPARE_DATA_FOR_ANALYSIS') {
          this.seqRunFlag = false;
        }

      } else {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Run Not Found', detail: 'Run not found with RunID ' + this.valueToSearch });
      }
      this.blocked = false;
    }, error: (error: any) => {
      let message = this.errorHandler.handleError(error);
      this._messagesService.addErrorMessage(message);
    }
    })
  }
  searchButtonDisabledIf() {
    return !(this.valueToSearch && this.valueToSearch.trim() != '');
  }

  getViewPlateIcon(plateViewStatus: boolean) {
    if (this.showPlateView) {
      return 'fa fa-list-alt';
    } else {
      return 'fa fa-th';
    }
  }

  getPlateViewButtonLabel(plateView: boolean) {
    if (plateView) {
      return 'View Process';
    } else {
      return 'View Lane';
    }
  }

  saveRunStatus(status: string) {
    if (this.selectedRun.runId == null || this.selectedRun.runId == undefined) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Run ID Empty', detail: 'Please enter Run ID to save' });
      return;
    }
    if (!this.isPUIDPresent()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    this.saveRunStatusAction(status);
  }

  saveRunStatusAction(status: string) {
    if (this.selectedRun.disassembling && status == 'PREPARE_DATA_FOR_ANALYSIS') {
      let dialogMessage = 'This preparation had been performed successfully at a previous time. Do you really want to restart this preparation and create new SampleSheet and RunConfig files?' + "<br/>" +
        'Note: Restarting will replace existing links in this view.';
      this.confirmationService.confirm({
        message: dialogMessage,
        header: 'Confirmation',
        icon: 'fa fa-question-circle',
        accept: () => {
          let functionName = this.mapOfStatusSaves.get(status);
          this[functionName](status);
        },
        reject: () => {

        }
      });
    } else {
      let functionName = this.mapOfStatusSaves.get(status);
      this[functionName](status);
    }
  }

  private saveSampleSheetData() {
    if (!this.selectedRun.runLanes || this.selectedRun.runLanes.length == 0) {
      this._messagesService.addErrorMessage({ severity: "error", summary: "No Libraries in Run", detail: "No libraries found in the run. Please select appropriate run." });
      return;
    }

    this.selectedRun.constraintIds = this.getConstraintIds(this.selectedRun);
    this.blocked = true;
    let prepareData = this.runProcessingService.prepareDataForAnalysis(this.selectedRun);
    prepareData.subscribe(results => {
      if (results.data) {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: "RunConfig and Samplesheet Creation Successful!",
          detail: 'Run ID: ' + this.selectedRun.runId
        });
        this.selectedRun = results.data;
        if (this.selectedRun.sampleSheetURL && this.selectedRun.runConfigURL && this.selectedRun.status == 'PREPARE_DATA_FOR_ANALYSIS') {
          this.seqRunFlag = false;
        }
        this.blocked = false;
      }
    }, error => {
      this.valueToSearch = this.selectedRun.runId;
      this.seqRunFlag = true;
      this.getDataForRunProcessing();
      this.handleError(error);
    }
    );
  }

  isPUIDPresent() {
    if (this.puid != null && this.puid != undefined && this.puid != '') {
      return true;
    }
    return false;
  }

  downloadSheet(fileName: string) {
    let downloadType = "runProcess_excel_download";
    let dataToUpload = { "fileName": fileName, "runId": this.selectedRun.runId };
    let jsonDataString: string = JSON.stringify(dataToUpload);
    this.blocked = true;
    this.runProcessingService.downloadSampleSheet(downloadType, jsonDataString).subscribe(
      result => {
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Intiating File download',
          detail: '',
        });
        var blob = new Blob([result.fileContent], { type: 'application/octet-stream' });
        this.blocked = false;
        saveByFileSaver(blob, fileName);
      },
      error => {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'File Not Found', detail: 'File not present on blob ' + fileName });
      }
    )
  }

  private handleError(error: any) {
    this.blocked = false;
    let message = this.errorHandler.handleError(error);
    this._messagesService.addErrorMessage(message);
  }

  prepareDataForAnalysis(status: string) {
    if (this.selectedRun.status === "PA_STARTED" || this.selectedRun.status === "SEQ_RUN_FINISHED" || this.selectedRun.status === "SEQ_RUN_STARTED") {
      this.dataSetForprepareDataForAnalysis();
    } else {
      this.dataSetForprepareDataForAnalysis();
      this.selectedRun.status = status;
    }

    this.saveSampleSheetData();
  }

  dataSetForprepareDataForAnalysis() {
    this.selectedRun.prepareDataForAnalysisPUID = this.puid;
    this.selectedRun.prepareDataForAnalysisDate = new Date();
  }

  downloadTemplate(event: any) {

    var target = event.target || event.srcElement || event.currentTarget;
    var idAttr = target.attributes.id;
    var value = idAttr.nodeValue;
    var comment = document.getElementById(value).innerText;

    this.downloadSheet(comment);

  }

  getFileNameFromComment(comment: string) {
    var file = comment.substring(0, comment.indexOf(' '));

    if ("Request" === file) {
      var a = comment.split(". ");
      file = a[1].trim();
      file = file.substring(0, file.indexOf(' '));
    }
    return file;
  }

  getPreviewComment() {
    let comment = new Comment();
    if (this.comments && this.comments.length > 0) {
      this.commentAvailable = false;
      comment = this.comments[this.comments.length - 1];
    }
    else if (!this.comments || this.comments.length == 0) {
      this.commentAvailable = true;
      comment.puid = '';
      comment.commentDate = null;
      comment.userComment = 'No Comments added';
      this.comments = [comment];
    } else {
      comment.userComment = 'No Comments added yet'
    }
    return comment;
  }

  showComments() {
    this.showCommentDialog = true;
  }

  isCommentViewDisabled() {
    return !this.selectedRun;
  }

  getConstraintIds(run: RunDetails) {
    let constraintIdSet: Set<string> = new Set<string>();
    run.runLanes.forEach(lane => {
      let runLane = lane.runLanes[0];
      if (runLane.constratintType && runLane.constratintType == "product") {
        constraintIdSet.add(runLane.constraintId);
      } else {
        constraintIdSet.add("none");
      }
    });

    return Array.from(constraintIdSet);
  }

  togglePlateView() {
    this.laneBlocks = [];
    this.showPlateView = !this.showPlateView;
    if (this.showPlateView) {
      this.getDataForLaneView();
    }
  }

  getDataForLaneView() {
    this.runActionSelection = null;
    this.expandedLane = null;
    this.laneBlocks = [];
    let map = {};
    this.selectedRun.runLanes.forEach((laneData: any) => {
      this.listofRunLibraries = [];
      laneData.runLanes.forEach(ipus => {
        this.listofRunLibraries = this.listofRunLibraries.concat(ipus.libraryId)
      });
      map[laneData.laneId] = this.listofRunLibraries
    });
    let dataToExport = { "labId": this.selectedLabId, "runId": this.selectedRun.runId, "mapOfrunWithLibraries": map };
    this.blocked = true;
    let runLaneView = this.runProcessingService.getListOfLaneView(dataToExport);
    runLaneView.subscribe({next : (results) => {
      if (results && results.data) {
        this.createLaneViewMap(results.data);
        this.setLaneViewData();
        this.lanePlacement();
      }
      this.blocked = false;
    }, error: (error: any) => {
      this.handleError(error);
    }});
  }

  createLaneViewMap(result: any) {
    this.laneViewMap = new Map();
    this.containerLibMap = new Map();
    this.laneSelectionMap = new Map();
    this.librarySelectionList = [];

    for (let [key, value] of Object.entries(result)) {
      if (value && value["NO_CONTAINER"]) {
        this.laneViewMap.set(key, this.clone(value["NO_CONTAINER"]));
        this.laneSelectionMap.set(key, []);
        for (let [k, v] of Object.entries(value)) {
          if (k != "NO_CONTAINER") {
            this.containerLibMap.set(k, v);
          }
        }
      }
    }
  }

  setLaneViewData() {
    this.laneViewData = [];
    this.selectedRun.runLanes.sort((d1, d2) => {
      if (d1.laneId < d2.laneId)
        return -1;
      else if (d1.laneId > d2.laneId)
        return 1;
      else
        return 0;
    });
    this.laneViewList = [];
    let totalReadCapacity = 0;
    let totalOccupiedCapacity;
    let laneBlock = new LaneBlock();
    laneBlock.name = PHIX_BLOCK_NAME;
    laneBlock.color = PHIX_COLOR;
    laneBlock.weightPercentage = 1;
    this.selectedRun.runLanes.forEach((laneDate: any) => {
      let laneData = new LaneViewDataDTO();
      let totalReads = 0;
      laneData.totalLibIds = 0;
      if (laneDate.runLanes.length > 0) {
        let runLaneAtFirstIndex = laneDate.runLanes[0];
        laneDate['runLanes'].forEach(run => {
          totalReads += run.weight;
          laneData.totalLibIds += run.libraryId.length;
        });
        let lastIndexRunData = laneDate['runLanes'].at(laneDate['runLanes'].length - 1);

        totalReadCapacity = (totalReads + runLaneAtFirstIndex.occupiedCapacity + lastIndexRunData.remainingCapacity);

        totalOccupiedCapacity = totalReads + runLaneAtFirstIndex.occupiedCapacity;

        laneData.laneId = laneDate.laneId;
        laneData.constraintId = runLaneAtFirstIndex.constraintId;
        let occupiedPercentage = Math.round(((totalOccupiedCapacity / totalReadCapacity) * 100) * 100) / 100;

        laneData.totalReadsCount = this.abbreviateNumber(totalOccupiedCapacity) + '  ( ' + occupiedPercentage + ' %)';

        laneData.phixPercentage = runLaneAtFirstIndex.phiXPercentage;
        this.laneViewList.push(laneData);
      }
    }, this);
  }

  abbreviateNumber(value: number) {
    let newValue = value;
    const suffixes = ["", "K", "M"];
    let suffixNum = 0;
    if (newValue >= 1000000) {
      suffixNum = 2;
      while (newValue >= 1000000) {
        newValue /= 1000000;
      }
    } else if (newValue >= 1000) {
      suffixNum = 1;
      while (newValue >= 1000) {
        newValue /= 1000;
      }
    }
    let newValueString = newValue.toFixed(1);
    if (newValueString) {
      newValueString = newValueString.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    newValueString += suffixes[suffixNum];
    return newValueString;
  }

  getRowsCount() {
    return this.libraryIdTabledata.length;
  }

  getValueforLib(field: string, library: any) {
    if (library[field]) {
      return library[field];
    } else {
      return '-';
    }
  }

  customSort(event: any) {
    let compResult = null;
    if (event.field == 'tagInfo') {
      event.data.sort((lib1: any, lib2: any) => {
        let libvalue1 = lib1[event.field][0].tagManufacturerindex + lib1[event.field][0].tagSequence ? lib1[event.field][0].tagManufacturerindex + lib1[event.field][0].tagSequence : null;
        let libvalue2 = lib2[event.field][0].tagManufacturerindex + lib2[event.field][0].tagSequence ? lib2[event.field][0].tagManufacturerindex + lib2[event.field][0].tagSequence : null;
        compResult = this.getSortResult(libvalue1, libvalue2);
        return (event.order * compResult);
      });
    } else {
      event.data.sort((lib1: any, lib2: any) => {
        let libvalue1 = lib1[event.field] ? lib1[event.field] : '';
        let libvalue2 = lib2[event.field] ? lib2[event.field] : '';
        compResult = this.getSortResult(libvalue1, libvalue2);
        return (event.order * compResult);
      });
    }
  }

  getSortResult(value1, value2) {
    if (value1 < value2) {
      return -1;
    }
    return (value1 > value2) ? 1 : 0;
  }

  lanePlacement() {
    this.laneBlockMap = new Map();

    let totalReads = 0;
    let totalReadCapacity = 0;

    this.selectedRun.runLanes.forEach((laneData: any) => {

      let laneBlock = new LaneBlock();
      laneBlock.name = PHIX_BLOCK_NAME;
      laneBlock.color = PHIX_COLOR;

      let overDueLaneBlock = new LaneBlock();
      overDueLaneBlock.name = OVERDUE_BLOCK_NAME;
      overDueLaneBlock.color = OVERDUE_COLOR;

      let dueLessLaneBlock = new LaneBlock();
      dueLessLaneBlock.name = DUELESS_BLOCK_NAME;
      dueLessLaneBlock.color = DUELESS_COLOR;

      let dueMoreLaneBlock = new LaneBlock();
      dueMoreLaneBlock.name = DUEMORE_BLOCK_NAME;
      dueMoreLaneBlock.color = DUEMORE_COLOR;

      this.laneBlocks = [];
      if (laneData.runLanes.length > 0) {
        let runLaneAtFirstIndex = laneData.runLanes[0];
        laneBlock.weightPercentage = runLaneAtFirstIndex.phiXPercentage;
        let lastIndexRunData = laneData['runLanes'].at(laneData['runLanes'].length - 1);
        totalReads = 0;
        laneData.runLanes.forEach(ipu => {

          totalReads += ipu.weight;
          if (ipu.dueDate < 2) {
            overDueLaneBlock.weight += ipu.weight;
            overDueLaneBlock.ipus.push(ipu);
          } else if (ipu.dueDate >= 2 && ipu.dueDate <= 5) {
            dueLessLaneBlock.weight += ipu.weight;
            dueLessLaneBlock.ipus.push(ipu);
          } else {
            dueMoreLaneBlock.weight += ipu.weight;
            dueMoreLaneBlock.ipus.push(ipu);
          }
        });
        totalReadCapacity = (totalReads + runLaneAtFirstIndex.occupiedCapacity + lastIndexRunData.remainingCapacity);
      }
      this.laneBlocks.push(laneBlock);
      this.lanePlacer(overDueLaneBlock, dueLessLaneBlock, dueMoreLaneBlock, totalReadCapacity, laneData);
      this.laneBlockMap.set(laneData.laneId, this.laneBlocks);
    });
  }

  lanePlacer(overDueLaneBlock: any, dueLessLaneBlock: any, dueMoreLaneBlock: any, totalReadCapacity: any, laneData: any) {
    if (overDueLaneBlock.weight > 0) {
      overDueLaneBlock.weightPercentage = Math.round(((overDueLaneBlock.weight / totalReadCapacity) * 100) * 100) / 100;
      this.laneBlocks.push(overDueLaneBlock);
      laneData.occupiedCapacity += overDueLaneBlock.weight;
    }
    if (dueLessLaneBlock.weight > 0) {
      dueLessLaneBlock.weightPercentage = Math.round(((dueLessLaneBlock.weight / totalReadCapacity) * 100) * 100) / 100;
      this.laneBlocks.push(dueLessLaneBlock);
      laneData.occupiedCapacity += dueLessLaneBlock.weight;
    }
    if (dueMoreLaneBlock.weight > 0) {
      dueMoreLaneBlock.weightPercentage = Math.round(((dueMoreLaneBlock.weight / totalReadCapacity) * 100) * 100) / 100;
      this.laneBlocks.push(dueMoreLaneBlock);
      laneData.occupiedCapacity += dueMoreLaneBlock.weight;
    }
  }

  getLaneBlockStyle(laneBlock: LaneBlock) {
    return {
      'width': laneBlock.weightPercentage + '%',
      'background-color': laneBlock.color,
      'border': (laneBlock.weightPercentage > 0) ? '0px solid black' : 'none'
    }
  }

  getLaneBlocks(laneId: any) {
    return this.laneBlockMap.get(laneId);
  }

  disablePrepareDataForAnalysisIf() {
    return !(this.selectedRun !== undefined && this.selectedRun !== null && (this.selectedRun.status === "DIL_AND_POOL_COMPLETED" || this.selectedRun.status === "RUN_SCHEDULED" || this.selectedRun.status === "PREPARE_DATA_FOR_ANALYSIS"
      || this.selectedRun.status === "PA_STARTED" || this.selectedRun.status === "SEQ_RUN_FINISHED"
      || this.selectedRun.status === "SEQ_RUN_STARTED"));
  }

  disableButtonIfRunNotSelected(){
    return !(this.selectedRun != undefined && this.selectedRun !== null)
  }

  disableStartDilutionAndPoolingButton(){
    return !(this.selectedRun != undefined && this.selectedRun !== null)
  }

  disableDNPWorkfile(){
    if(!(this.selectedRun && this.selectedRun.dilutionAndPoolingStartedDateTime && this.selectedRun.dilutionAndPoolingStartedPUID)){
      return true
    }
    return false
  }

  disableCompleteDilAndPool(){
    if(!(this.selectedRun && this.selectedRun.dnpWorkfileDateTime && this.selectedRun.dnpWorkfilePUID)){
      return true
    }
    return false
  }

  disableSeqRunStarted(){
    if(!(this.selectedRun && this.selectedRun.dilutionAndPoolingFinishedDateTime && this.selectedRun.dilutionAndPoolingFinishedPUID)){
      return true
    }
    return false
  }

  seqRunStartedPresent(){
    if(this.selectedRun && this.selectedRun.sequencingRunStartedDate && this.selectedRun.sequencingRunStartedPUID){
      return true
    }
    return false
  }

  disableReRunSeq(){
    if(!(this.selectedRun && this.selectedRun.sequencingRunStartedDate && this.selectedRun.sequencingRunStartedPUID)){
      return true
    }
    return false
  }

  completeDilAndPoolPresent(){
    if(this.selectedRun.dilutionAndPoolingFinishedDateTime && this.selectedRun.dilutionAndPoolingFinishedPUID){
      return true
    }
    return false
  }

  startDilAndPoolPresent(){
    if(this.selectedRun && this.selectedRun.dilutionAndPoolingStartedDateTime && this.selectedRun.dilutionAndPoolingStartedPUID){
      return true
    }
    return false
  }

  seqRunFinishedPresent(){
    if(this.selectedRun && this.selectedRun.sequencingRunFinishedDateTime && this.selectedRun.sequencingRunFinishedPUID){
      return true
    }
    return false
  }

  disableSeqRunFinished(){
    if(!(this.selectedRun && this.selectedRun.sequencingRunStartedDate && this.selectedRun.sequencingRunStartedPUID)){
      return true
    }
    return false
  }

  disableRunFeedbackReceived(){
    if(!(this.selectedRun && this.selectedRun.sequencingRunFinishedDateTime && this.selectedRun.sequencingRunFinishedPUID)){
      return true
    }
    return false
  }

  disableRunCompleted(){
    if(this.selectedRun.runFeedbackReceivedDateTime && this.selectedRun.runFeedbackReceivedPUID && !this.selectedRun.completionDateTime && !this.selectedRun.completionPUID){
      return false
    }
    return true
  }

  disableIfReRunRun(){
    if(this.selectedRun.status = "RERUN_RUN"){
      return true;
    }
    return false;
  }

  runFeedbackReceivedPresent(){
    if(this.selectedRun && this.selectedRun.runFeedbackReceivedDateTime && this.selectedRun.runFeedbackReceivedPUID){
      return true
    }
    return false
  }

  disableReRunSequencingRun(){
    if(!(this.selectedRun && this.selectedRun.runFeedbackReceivedDateTime && this.selectedRun.runFeedbackReceivedPUID)){
      return true
    }
    return false
  }

  
  disableCompleteDilutionAndPoolingButton(){
    return !(this.selectedRun != undefined && this.selectedRun !== null)
  }

  saveComment() {
    this.newComment.commentDate = new Date();
    this.newComment.userComment = this.newComment.userComment.trim();
    this.newComment.puid = this.puid
    this.blocked = true;
    this.runProcessingService.saveComment(this.selectedRun.runId, this.selectedLabId, this.newComment).subscribe({
      next : (result) => {
        this.blocked = false;
        this.selectedRun = result.data;
        this.comments = this.selectedRun.comments;
        this.previewComment = this.getPreviewComment();
        this.newComment = new Comment()

        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Comment Saved', detail: 'Comment saved successfully' });
      },
      error: (error: any) => {
        this.handleError(error);
      }
    })

  }

  disableAddCommentButton(): boolean {
    return !(this.newComment.userComment && this.newComment.userComment.trim() != '')
  }

  clearComment() {
    this.newComment = new Comment();
  }

  isMoreButtonDisabled(lane: any) {
    return ((this.laneLibFilterValue && this.laneLibFilterValue.trim() != '') ||
      (this.laneViewMap.has(lane["laneId"]) && ((this.laneViewMap.get(lane["laneId"]).length == 0) || (this.rowsCount >= this.laneViewMap.get(lane["laneId"]).length))));
  }

  onRowExpand(event) {
    if (this.expandedLane) {
      this.laneSelectionMap.set(this.expandedLane, this.clone(this.librarySelectionList));
    }
    this.expandedLane = event.data.laneId;
    if (event.data) {
      this.rowsCount = 50;
      let laneData = this.laneViewMap.get(event.data.laneId);
      if (laneData && laneData.length < this.rowsCount) {
        this.rowsCount = laneData.length
      }
      this.laneLibFilterValue = '';
      this.loading = false;
      this.libraryIdTabledata = this.laneViewMap.get(event.data.laneId).slice(0, this.rowsCount);
      this.librarySelectionList = this.clone(this.laneSelectionMap.get(event.data.laneId));
    }
  }

  moreToshow(rowData: any) {
    this.loading = true;
    this.laneLibFilterValue = '';
    this.rowsCount += 50;
    let laneView = this.laneViewMap.get(rowData.laneId);
    if (this.rowsCount > laneView.length) {
      this.rowsCount = laneView.length;
    }
    setTimeout(() => {
      this.libraryIdTabledata = laneView.slice(0, this.rowsCount);
      this.loading = false;
    }, 50);
  }

  globalfilterLibrayTable(value: string, lane: any) {
    if (value) {
      this.libraryIdTabledata = this.globalFilter(this.laneViewMap.get(lane["laneId"]), value)
    } else {
      this.libraryIdTabledata = this.laneViewMap.get(lane["laneId"]).slice(0, this.rowsCount);
    }
  }

  globalFilter(itemList: any, searchKeyword: string) {
    let filteredList = [];
    if (itemList.length > 0) {
      searchKeyword = searchKeyword.toLowerCase();
      itemList.forEach(item => {
        let propValueList = Object.values(item); // get list of all values from item
        this.getFilteredListFromLoop(propValueList, item, searchKeyword, filteredList);
      });
    }
    return filteredList;
  }

  getFilteredListFromLoop(propValueList, item, searchKeyword, filteredList) {
    if (item.dueDate && this.getCheckForOtherData(this.getDate(item.dueDate), searchKeyword)) {
      filteredList.push(item);
      return filteredList;
    }
    if (item.missingReads) {
      let missingReads = this.abbreviateNumber(item.missingReads);
      if (this.getCheckForOtherData(missingReads, searchKeyword)) {
        filteredList.push(item);
        return filteredList;
      }
    }
    if (item.tagInfo && this.checkForTagInfo(item, searchKeyword.replace(/\s/g, ''))) {
      filteredList.push(item);
      return filteredList;
    }

    if (item.containedLibs && (item.containedLibs.length > 0) && item.containedLibs.includes(searchKeyword)) {
      filteredList.push(item);
      return filteredList;
    }

    for (let probVal of propValueList) { // [libraryId, dueDate, missingReads, sampleName, project, status, tag]
      if (this.getCheckForOtherData(probVal, searchKeyword)) {
        filteredList.push(item);
        break;
      }
    }
  }
  checkForTagInfo(item: any, searchKeyword: any) {
    return this.getCheckForOtherData(item.tagInfo[0].tagManufacturerindex, searchKeyword) || this.getCheckForOtherData(item.tagInfo[0].tagSequence, searchKeyword) ||
      this.getCheckForOtherData(item.tagInfo[0].tagManufacturerindex + item.tagInfo[0].tagSequence, searchKeyword);
  }

  getDate(date: any) {
    if (date) {
      return this.datepipe.transform(date, 'dd.MM.yyyy');
    }
    return null;
  }
  getCheckForOtherData(probVal: any, searchKeyword: any) {
    return (probVal && probVal.toString().toLowerCase().indexOf(searchKeyword) > -1);
  }

  isLibraryContainer(library: any) {
    return (library && library["containedLibs"] && library["containedLibs"].length > 0)
  }

  getContainerLibraries(containerLib: string) {
    return this.containerLibMap.has(containerLib) ? this.containerLibMap.get(containerLib) : [];
  }

  getTotalLibsCount(lane: any) {
    if (this.laneViewMap.has(lane["laneId"])) {
      return this.laneViewMap.get(lane["laneId"]).length;
    }
    return 0;
  }

  getSelectLibCount() {
    return this.librarySelectionList.length;
  }

  getSelectLibCountForLane(laneId: string) {
    return this.laneSelectionMap.get(laneId) ? this.laneSelectionMap.get(laneId).length : 0;
  }

  onRowClose(event: any) {
    this.expandedLane = null;
    this.laneSelectionMap.set(event.data.laneId, this.clone(this.librarySelectionList));
  }

  showRemovalSideBar() {
    this.removelErrorReutrnMessage = null;
    this.removalEmptyLibsMessage = null;

    if (!["RUN_SCHEDULED", "RUN_PLANNED"].includes(this.selectedRun.status)) {
      this.removalEmptyLibsMessage = "Removing libs allowed only for Run statuses: RUN_SCHEDULED, RUN_PLANNED.";
      this.showRemoveLibsSideBar = true;
      return;
    }
    this.userEmail = null;
    this.userPassword = null;
    if (this.expandedLane) {
      this.laneSelectionMap.set(this.expandedLane, this.librarySelectionList);
    }

    this.removalLibraryObjects = [];
    this.removalLibraryIds = [];
    this.removalContainedLibIds = [];
    this.libraryCount = 0;
    this.laneSelectionMap.forEach((value: any[], key: string) => {
      value.forEach(lib => {
        this.removalLibraryObjects.push({ 'libraryId': lib["libraryId"], 'project': lib["projectName"] });
        this.removalLibraryIds.push(lib["libraryId"]);
        if (lib['containedLibs'] && lib['containedLibs'].length > 0) {
          this.removalContainedLibIds = this.removalContainedLibIds.concat(lib['containedLibs']);
        }
      });
      this.libraryCount += value.length;
    });

    if (this.libraryCount == 0) {
      this.removalEmptyLibsMessage = "There are no libraries to remove. Please select libraries to remove and then click Go.";
    } else {
      this.removalEmptyLibsMessage = null;
    }
    this.showRemoveLibsSideBar = true;
  }

  submitRemoval() {
    if (this.validateEmailID(this.userEmail)) {
      this.removelErrorReutrnMessage = null;
    } else {
      this.removelErrorReutrnMessage = 'Email is invalid';
      return;
    }
    let runCopy = this.clone(this.selectedRun);
    let comment = new Comment();
    comment.puid = this.getUserIdFromEmail(this.userEmail);
    comment.commentDate = new Date();
    comment.userComment = "";

    let commentList: string[] = [];

    this.runCopyCreator(runCopy, commentList, comment);

    this.blocked = true;
    this.runProcessingService.removeLibs(runCopy).subscribe(
      result => {
        this.removelErrorReutrnMessage = null;
        this.removalEmptyLibsMessage = null;
        this.togglePlateView();
        this.selectedRun = result.data;
        this.comments = this.selectedRun.comments;
        this.previewComment = this.getPreviewComment();
        this.showRemoveLibsSideBar = false;
        this.blocked = false;
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this.removelErrorReutrnMessage = message.detail;
      }
    );
  }

  private runCopyCreator(runCopy: RunDetails, commentList: string[], comment: Comment) {
    runCopy["runLanes"].forEach(lane => {
      if (lane["runLanes"] && lane["runLanes"].length > 0) {
        lane["runLanes"].forEach(ipu => {
          ipu["libraryId"] = ipu["libraryId"].filter(libId => !this.removalLibraryIds.includes(libId));
        });
      }
      lane["runLanes"] = lane["runLanes"].filter(ipu => (ipu.libraryId && ipu.libraryId.length > 0));
    });

    runCopy["runLanes"] = runCopy["runLanes"].filter(lane => (lane["runLanes"] && lane["runLanes"].length > 0));

    if (runCopy["runLanes"] && runCopy["runLanes"].length > 0) {
      this.laneSelectionMap.forEach((value: any[], key: string) => {
        if (value.length > 0) {
          if (this.laneViewMap.get(key).length == value.length) {
            commentList.push(key + " has been removed\n");
          } else {
            commentList.push(key + ": Lib(s) " + this.getLibsString(value) + " have been removed.");
          }
        }
      });
      commentList.sort((a, b) => a.localeCompare(b));
      comment.userComment = "Run has been modified as follows:\n";
      commentList.forEach(cmnt => {
        comment.userComment += cmnt + "\n";
      });
    } else {
      comment.userComment = "Run has been removed";
      runCopy.status = "CANCELED";
    }

    runCopy.removedLibraries = this.removalLibraryIds.concat(this.removalContainedLibIds);
    if (runCopy.comments && runCopy.comments.length > 0) {
      runCopy.comments.push(comment);
    } else {
      runCopy.comments = [comment];
    }
    runCopy.userEmail = this.userEmail;
    runCopy.password = this.convertStringToUTF8ByteArray(this.userPassword);
  }

  getLibsString(libs: any[]) {
    let cmntString = libs[0]['libraryId'];
    for (let i = 1; i < libs.length; i++) {
      cmntString += ", " + libs[i]['libraryId'];
    }
    return cmntString;
  }

  showRunCompletionSidebar() {
    this.sequencingRunContinuationValue = 'complete';
    this.processViewSidebar = true;
    this.userEmail = '';
    this.userPassword = '';
  }

  submitRunDecisionOnSequencingCompleted() {
    if (this.sequencingRunContinuationValue == 'complete') {
      this.seqRunFinished('SEQ_RUN_FINISHED')
    } else {
      if (!(this.userEmail && this.userEmail.trim() != '') || !(this.userPassword && this.userPassword.trim() != '')) {
        this._messagesService.addErrorMessage({ severity: 'error', summary: 'Please enter both username & password.' });
        return;
      }
      this.selectedRun.userEmail = this.userEmail;
      this.selectedRun.password = this.convertStringToUTF8ByteArray(this.userPassword);
      this.selectedRun.sequencingRunFinishedDateTime = new Date();
      this.selectedRun.sequencingRunFinishedPUID = this.puid;

      this.blocked = true;
      this.runProcessingService.redoRun(this.selectedRun).subscribe(
        result => {
          this.selectedRun = result.data;
          this.comments = this.selectedRun.comments;
          this.previewComment = this.getPreviewComment();
          this.processViewSidebar = false;
          this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Run has been cancelled!', detail: 'Redo is successful & Run status has been changed to FAILED.' });
          this.blocked = false;
          this.removeRunSelection()
          this.reloadRuns()
        }, error => {
          this.handleError(error);
        }
      )
    }
  }

  convertStringToUTF8ByteArray(str) {
    let data = [];
    for (let i = 0; i < str.length; i++) {
      data.push(str.charCodeAt(i));
    }
    return data;
  }

  isRunActionDisabled() {
    return (!this.runActionSelection);
  }

  closeRemovalSideBar() {
    this.showRemoveLibsSideBar = false;
  }

  isSubmitDisabled() {
    return !(this.validateEmailID(this.userEmail) && this.userPassword && (this.userPassword.length > 0));
  }

  validateEmailID(emailID: string) {
    if (emailID) {
      const emailRegex = /^([a-zA-Z0-9]{4})@[a-zA-Z0-9.]*\.com$/;
      const matches = emailID.match(emailRegex);
      return matches;
    } else {
      return false;
    }
  }

  getUserIdFromEmail(emailID: string) {
    let value = this.validateEmailID(emailID);
    return value[1];
  }

  downloadDilutionPoolingWorkFile(status: string){
    if (this.selectedRun.runId == null || this.selectedRun.runId == undefined) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Run ID Empty', detail: 'Please enter Run ID to save' });
      return;
    }
    if (!this.isPUIDPresent()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }
    this.selectedRun.dnpWorkfilePUID = this.puid
    this.selectedRun.dnpWorkfileDateTime = new Date()
    this.selectedRun.status = status  

    let requestData: DilutionPooling = {runId:this.selectedRun.runId, flowcell:this.selectedRun.flowcell,labId:this.selectedRun.lab,libraryIds:this.selectedRun.libraryIds,libraryInfo:this.libraryInfo, plannedReadsPoolLibs: this.selectedRun.plannedReadsPoolLibs};
    this.blocked = true;
    this.runProcessingService.downloadDilutionPoolingWorkFile(requestData).subscribe(
        result => {
          this._messagesService.addSuccessMessage({
            severity: 'success', summary: 'Dilution Pooling WorkFile Download',
            detail: '',
          });
          let txtData = result.data;
          let blobTxt: Blob = new Blob([txtData], { type: 'application/octet-stream' });
          let fileTxt: string = "DilutionPooling_WorkFile_.csv"
          saveByFileSaver(blobTxt, fileTxt);
          this.blocked = false;
        },
        error => {
          this.blocked = false;
          let message = this.errorHandler.handleError(error);
          this._messagesService.addErrorMessage(message);
        }
      )
  }

  downloadSampleSheetWorkFile(status: string) {
    if (this.selectedRun.runId == null || this.selectedRun.runId == undefined) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'Run ID Empty', detail: 'Please enter Run ID to save' });
      return;
    }
    if (!this.isPUIDPresent()) {
      this._messagesService.addWarningMessage({ severity: 'warn', summary: 'User ID Empty', detail: 'Please enter User ID to save' });
      return;
    }

    this.selectedRun.runLanes.forEach(lane=>{
      if(lane.runLanes){
        lane.runLanes.forEach(element => {
           this.runLaneslibraryIds = this.runLaneslibraryIds.concat(element.libraryId)
        });
      }
    })

    let dataToExport = { "lab": this.selectedLabId, "runId": this.selectedRun.runId, "libraryIds": this.runLaneslibraryIds, "puid": this.puid };
    this.blocked = true;
    this.runProcessingService.downloadSampleSheetWorkFile(dataToExport).subscribe(
      result => {
        this.blocked = false;
        this._messagesService.addSuccessMessage({
          severity: 'success', summary: 'Sample Sheet WorkFile Download',
          detail: '',
        });
        let txtData = result.data;
        let blobTxt: Blob = new Blob([txtData], { type: 'application/octet-stream' });
        let fileTxt: string = this.selectedRun.runId + ".csv"
        saveByFileSaver(blobTxt, fileTxt);
      },
      error => {
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )

  }

  onFileSelect(event){
    if(event.target.files[0].name.split('.').pop() != "json"){
      this.isRunFeedbackFileNotSelected = true;
      this._messagesService.addErrorMessage({
        severity: 'error', summary: 'Invalid File Type!!',
        detail: 'Only Json files are allowed.',
      });
    }else{
      this.isRunFeedbackFileNotSelected = false;
    }
  }

  fileUpload(fileInput: HTMLInputElement){
    const formData = new FormData();
    formData.append('file', fileInput.files[0]);
    this.blocked = true;
    this.runProcessingService.uploadRunFeedbackFile(formData, this.selectedRun._id, this.selectedLabId).subscribe(
      result => {
        let data = JSON.parse(result.data);
        fileInput.value = null;
        this.blocked = false;
        this.isRunFeedbackFileNotSelected = true;
        if (!result) {
          return;
        }
        this._messagesService.addSuccessMessage({ severity: 'success', summary: 'Upload Successful', detail: 'Feedback file has been uploaded successfully' });
        this.libraryData = data.data;
        this.showFeedbackDialog = true;
        this.saveRunStatus("RUN_FEEDBACK_RECEIVED");
      },
      error => {
        fileInput.value = null;
        this.isRunFeedbackFileNotSelected = true;
        this.blocked = false;
        let message = this.errorHandler.handleError(error);
        this._messagesService.addErrorMessage(message);
      }
    )
  }
}

